export enum RegisteredUserMismatchErrorType {
    None = 0,
    CustomerIdMismatch = 1,
    EmailMismatch = 2,
    NoMismatch = 3,
    Other = 999
}
